"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var _table_1 = tslib_1.__importDefault(require("../_components/_table"));
var usePersistFn_1 = tslib_1.__importDefault(require("../util/hooks/usePersistFn"));
var _a = _table_1.default.Summary, Row = _a.Row, Cell = _a.Cell;
var divide = function (numerator, denominator) {
    if (denominator) {
        return numerator / denominator;
    }
    return 0;
};
var baseTotalKeys = [
    'impression',
    'click',
    'ctr',
    'spend',
    'roi',
    'orderNum',
    'cpc',
    'cvr',
    'gmv',
    'cpm',
    'mallFavNum',
    'goodsFavNum',
    'transactionCost',
    'inquiryNum',
    'liveClickNum',
    'liveCommentNum',
    'costPerMallFav',
    'mallFavRate',
    'nonFanSpend',
    'nonFanClickNum',
    'avgPayAmount',
];
var getTotalItem = function (dataSource, customSummaryList) {
    var otherTotalKeys = customSummaryList.map(function (summary) { return summary.key; });
    var totalRecord = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(baseTotalKeys), false), tslib_1.__read(otherTotalKeys), false).reduce(function (total, key) {
        var _a;
        return tslib_1.__assign(tslib_1.__assign({}, total), (_a = {}, _a[key] = 0, _a));
    }, {});
    var totalItem = tslib_1.__assign(tslib_1.__assign({}, totalRecord), { summaryKey: 'total' });
    dataSource.forEach(function (item) {
        Object.keys(totalItem).forEach(function (key) {
            if (key !== 'summaryKey' && item.hasOwnProperty(key)) {
                totalItem[key] += item[key] || 0;
            }
            else if (item.children && Array.isArray(item.children)) {
                item.children.forEach(function (e) {
                    if (key !== 'summaryKey') {
                        totalItem[key] += e[key] || 0;
                    }
                });
            }
        });
    });
    // 对几个特殊的参数进行特殊计算
    // 点击率 = 点击量 / 曝光量
    totalItem.ctr = divide(totalItem.click, totalItem.impression);
    // 平均点击花费 = 花费 / 点击量
    totalItem.cpc = divide(totalItem.spend, totalItem.click);
    // 投入产出比 = 交易额 / 花费
    totalItem.roi = divide(totalItem.gmv, totalItem.spend);
    // 点击转化率 = 点击量 / 订单量
    totalItem.cvr = divide(totalItem.orderNum, totalItem.click);
    // 千次曝光花费 = 花费 / （曝光量 / 1000）
    totalItem.cpm = divide(totalItem.spend, totalItem.impression / 1000);
    // 平均成交花费 = 花费 / 订单量
    totalItem.transactionCost = divide(totalItem.spend, totalItem.orderNum);
    // 每笔成交金额 = 交易额 / 成交笔数
    totalItem.avgPayAmount = divide(totalItem.gmv, totalItem.orderNum);
    //  店铺关注成本 = 非粉丝推广消耗/新增粉丝关注数
    totalItem.costPerMallFav = divide(totalItem.nonFanSpend, totalItem.mallFavNum);
    //  吸粉率 = 新增粉丝关注数/非粉丝收费点击数
    totalItem.mallFavRate = divide(totalItem.mallFavNum, totalItem.nonFanClickNum);
    //  店铺关注成本 = 非粉丝推广消耗/新增粉丝关注数
    totalItem.costPerMallFav = divide(totalItem.nonFanSpend, totalItem.mallFavNum);
    //  吸粉率 = 新增粉丝关注数/非粉丝收费点击数
    totalItem.mallFavRate = divide(totalItem.mallFavNum, totalItem.nonFanClickNum);
    customSummaryList.forEach(function (_a) {
        var key = _a.key, getTotal = _a.getTotal;
        if (!getTotal) {
            return;
        }
        totalItem[key] = getTotal(totalItem);
    });
    return totalItem;
};
var useTableTotal = function (props) {
    var dataSource = props.dataSource, columns = props.columns, _a = props.withCheckbox, withCheckbox = _a === void 0 ? false : _a, _b = props.totalText, totalText = _b === void 0 ? '本页合计' : _b, _c = props.customSummaryList, customSummaryList = _c === void 0 ? [] : _c;
    var record = (0, react_1.useMemo)(function () {
        return getTotalItem(dataSource, customSummaryList);
    }, [dataSource, customSummaryList]);
    var summary = (0, usePersistFn_1.default)(function () {
        if (!dataSource.length) {
            return null;
        }
        return (react_1.default.createElement(Row, null,
            withCheckbox && react_1.default.createElement(Cell, { index: 0 }),
            columns.map(function (column, index) {
                var idx = withCheckbox ? index + 1 : index;
                var dataIndex = column.dataIndex, render = column.render, sorter = column.sorter, className = column.className, align = column.align;
                var jsx = render ? render(record[dataIndex], record) : record[dataIndex];
                if (index === 0) {
                    return (react_1.default.createElement(Cell, { index: idx, key: idx }, totalText));
                }
                return (react_1.default.createElement(Cell, { index: idx, key: idx, align: align, className: (0, classnames_1.default)({ 'column-with-sorter': !!sorter }, className) }, jsx));
            })));
    });
    return { tableProps: { summary: summary }, totalRecord: record };
};
exports.default = useTableTotal;
//# sourceMappingURL=useTableTotal.js.map